import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {API_URL} from "../../api/apiBase";
import {Input} from "../ui/input";
import {Button} from "../ui/button";
import {Spinner} from "../ui/spinner";
import {AnonymousHeader} from "../../layouts/Header";


export function QlinkPageWithEmail() {
    const {quid} = useParams();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [linkIsValid, setLinkIsValid] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    // Validate link exists on mount
    useEffect(() => {
        fetch(`${API_URL}/qlink/${quid}`)
            .then(res => {
                if (res.ok) setLinkIsValid(true);
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    }, [quid]);

    // Submit email → get magic link → redirect
    const handleSubmit = async () => {
        setIsSubmitting(true);
        setError('');
        try {
            const response = await fetch(`${API_URL}/qlink/${quid}/auth`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email}),
            });
            // console.log(response);
            if (response.ok) {
                const data = await response.json();
                // Redirect to PropelAuth magic link — logs them in and sends to project
                window.location.href = data.redirect_url;
            } else if (response.status === 403) {
                setError('This email is not authorized for this invite.');
                setIsSubmitting(false);
            } else {
                setError('Something went wrong. Please try again.');
                setIsSubmitting(false);
            }
        } catch (e) {
            setError('Could not connect to server.');
            setIsSubmitting(false);
        }
    };

    if (isLoading) return <Spinner/>;

    if (!linkIsValid) {
        return <div className="min-h-screen flex items-center justify-center">
            <p>This invite link is invalid or has expired.</p>
        </div>;
    }

    return <div className="min-h-screen flex flex-col">
        <AnonymousHeader/>
        <div className="flex-1 flex items-center justify-center">
            <div className="max-w-sm w-full p-6 space-y-4">
                <h2 className="text-xl font-semibold">Enter your email to access this project</h2>
                <Input
                    type="email"
                    placeholder="you@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && email && handleSubmit()}
                />
                {error && <p className="text-sm text-red-600">{error}</p>}
                <Button
                    onClick={handleSubmit}
                    disabled={!email || isSubmitting}
                    className="w-full"
                >
                    {isSubmitting ? 'Redirecting...' : 'Continue'}
                </Button>
                <p className="text-xs text-gray-500 text-center">
                    You'll receive access to view and bid on this project.
                </p>
            </div>
        </div>
    </div>;
}
